<template lang="html">
  <div class="block">
    <div class="block-main" v-if="!isLogined">
      <img src="./images/logout.png"  alt="">
      <p>登录后才能看到属于你的课程哦</p>
      <UIButton width="459" class="main-btn" @click="$emit('handleLogin')">立即登录</UIButton>
    </div>
    <div class="block-main" v-else>
      <img src="./images/login.png" alt="">
      <p>你还没有购买任何课程哦</p>
      <UIButton width="459" class="main-btn" @click="$router.push('/recommend')">去选课</UIButton>
    </div>
    <p></p>
  </div>
</template>

<script>
import UIButton from '../UI/Button'
export default {
  name: 'Block',
  props: ['isLogined'],
  components: {
    UIButton
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.block {
  width:rem(690);
  height:rem(540);
  background:rgba(255,255,255,1);
  box-shadow:0 rem(2) rem(30) 0 rgba(189,201,209,0.56);
  border-radius: rem(10);
  margin: rem(30) auto rem(60) auto;
  display: flex;
  align-items: center;
  justify-content: center;
  &-main {
    text-align: center;
    * {
      margin: auto;
    }
    img {
      width: rem(290);
      height: rem(233);
    }
    p {
      font-size: rem(24);
      color: #999;
      margin-bottom: rem(55);
    }
  }
}

.main-btn {
  background: $globalColor;
}
</style>
